import { isEmpty, noop, template } from 'lodash';
import ApplicationController from './application_controller';

const BOTONES_TEMPLATE = template(`
<div class="form-actions">
  <span class="extra-actions"></span>
  <button type="button" class="btn btn-default btn-cifra-clean">
    <i class="fa fa-eraser"></i> <%= I18n.t('Limpiar') %>
  </button>
  <!-- FIXME: No se puede quitar el data-disable-with hasta que no se migren los listados -->
  <button type="submit" class="btn btn-cifra btn-cifra-filter" data-disable-with="<i class='fa fa-circle-notch fa-spin'></i> <%= I18n.t('buscando') %>...">
    <i class="fa fa-search"></i> <%= I18n.t('Buscar') %>
  </button>
</div>
`);

/* global Mn, $, Cifra, set_overlay, init_datepicker, toggleFiltersWrapper */
const ListadoView = Mn.View.extend({
  template: noop,
  ui: {
    form: '.cifra-listado-filters form',
    body: '.cifra-listado-body',
  },
  events: {
    'click th[data-sortable]': 'sortTable',
    'click .btn-cifra-clean': 'serverClean',
    'ajax:complete @ui.form': 'onFormComplete',
  },
  objectOptions: ['cleanUrl', 'hideFiltersOnSearch', 'hideCleanButton'],
  initialize(options) {
    this.mergeOptions(options, this.objectOptions);
  },
  setBody(html) {
    this.getUI('body').html(html);
    this.runDefaultViewActions();
    this.$el[0].dispatchEvent(new CustomEvent('listado:updated'));
  },
  sortTable(e) {
    const $form = this.getUI('form');
    const $column = $(e.currentTarget);
    const sort = $column.data('sortable-dir') || 'asc';
    this.$('[id$=sort_field]:hidden').val($column.data('sortable'));
    this.$('[id$=sort_direction]:hidden').val(sort);
    this.$('[id$=sort_key]:hidden').val($column.data('sort-key'));
    $form.submit();
  },
  serverClean(e) {
    e.preventDefault();
    if (this.hideCleanButton) {
      return;
    }
    set_overlay(this.$el);

    let url;

    if (this.cleanUrl) {
      url = this.cleanUrl;
    } else {
      url = `${this.getUI('form').attr('action')}?clean=true`;
    }
    window.location = url;
  },
  onRender() {
    // Ponemos los botones dentro del form que ya habrán asignado
    const $form = this.getUI('form');
    // Configuramos remote con jquery-ujs
    $form.data('remote', true);
    $form.append(BOTONES_TEMPLATE());
    // Si hay botones extra, los colocamos dentro del formulario
    const $buttons = this.$('#extra-form-buttons');
    if ($buttons.length) {
      $buttons.children().appendTo($form.find('.extra-actions'));
      $buttons.remove();
    }
    if (this.hideCleanButton) {
      this.$('.btn-cifra-clean').hide();
    }
  },
  onFormComplete(e, xhr, _status) {
    this.setSearchToken(xhr);
  },
  // En el elemento padre del listado nos pueden enviar acciones a ejecutar
  runDefaultViewActions() {
    Cifra.App.loadComponents(this.getUI('body'));
    // TODO: Esto debería ser un componente más
    init_datepicker();

    if (this.hideFiltersOnSearch) {
      toggleFiltersWrapper();
    }
  },
  setSearchToken(xhr) {
    const searchToken = xhr.getResponseHeader('X-Cifra-SearchToken');
    if (isEmpty(searchToken)) {
      return;
    }
    // Nos llega el search token de la nueva búsqueda, actualizamos el campo
    // oculto del formulario con el token de la búsqueda actual
    $('.search_token').val(searchToken);
  },
});

export default class extends ApplicationController {
  connect() {
    this.component = new ListadoView({ el: this.element, ...this.element.dataset }).render();
    this.lanzarEventoCargado();
  }

  setBody(html) {
    this.component.setBody(html);
  }

  // En principio siempre preservamos la página, si surge algún caso en el que
  // no queramos que sea así, tendremos que hacerlo configurable
  lanzarBusqueda() {
    const $form = this.component.getUI('form');

    const $inputPreservePage = $('<input name="preserve_page" value="true" type="hidden">');
    $inputPreservePage.appendTo($form);
    $form[0].requestSubmit();
    $inputPreservePage.remove();
  }
}
